import api, { API_URL } from './api';

export const catalogueService = {
    // Get list of studios
    getStudios: async () => {
        const response = await api.get('/catalogues/studios');
        return response.data;
    },

    // Request OTP for catalogue access
    requestOTP: async (email, studio) => {
        const response = await api.post('/catalogues/request-otp', {
            email,
            studio
        });
        return response.data;
    },

    // Verify OTP
    verifyOTP: async (email, otp, studio) => {
        const response = await api.post('/catalogues/verify-otp', {
            email,
            otp,
            studio
        });
        return response.data;
    },

    // Get catalogue view URL - uses dynamic API_URL from environment
    getCatalogueURL: (studio, token) => {
        return `${API_URL}/catalogues/view/${studio}?token=${token}`;
    }
};

